import { tv } from 'tailwind-variants';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';
import { cn } from '@/utils/cn-tw-merge';

export interface EntitySectionProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  icon?: IconDefinition;
  classNameIcon?: string;
  removeHr?: boolean;
  titleStyles?: string;
}

const entitySectionStyles = tv({
  slots: {
    container: ['my-6'],
    icon: ['text-gray-500 text-lg mr-2 transition-transform duration-300 w-6 h-7'],
  },
});

export function EntitySection({ title, icon, classNameIcon, removeHr, titleStyles, ...props }: EntitySectionProps) {
  const { container, icon: iconStyle } = entitySectionStyles();

  const { className, ...rest } = props;

  return (
    <>
      <section className={container({ className })} {...rest}>
        {(icon || title) && (
          <div className="flex items-start">
            {icon && (
              <div className="flex items-center">
                <Icon
                  icon={icon}
                  className={iconStyle({ className: classNameIcon })}
                  data-testid={DataTestIdEnum.ENTITY_SECTION_ICON}
                />
              </div>
            )}
            <div>
              <h2 className={cn('text-gray-800 text-xl font-semibold mb-2', titleStyles)}>{title}</h2>
            </div>
          </div>
        )}

        <div className="w-full truncate">{props.children}</div>
      </section>
      {!removeHr && <hr />}
    </>
  );
}
